import type { FigureCreationPanelFragment } from "../../client/generated";
import { AttributePanel } from "../AttributePanel";
import { useTranslation } from "react-i18next";
import { useCreateFigureFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: FigureCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function FigureCreationPanel({ fragment, onDelete }: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateFigureFromPanelMutation();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("FigureCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
